import { Nowrap } from '@farmersdog/corgi-x';
import {
  DeliveredIconSvg,
  HeartIconSvg,
  IngredientsIconSvg,
  SaucepanIconSvg,
} from './assets';
import type { HeroIconItem } from 'src/pages/HomepageRedesign/types';

export const olsValueProps: HeroIconItem[] = [
  {
    id: 'human-grade-safety',
    icon: IngredientsIconSvg,
    iconLabel: 'Dog food ingredients',
    text: (
      <>
        <Nowrap>Human-grade</Nowrap> <Nowrap>safety standards</Nowrap>
      </>
    ),
  },
  {
    id: 'delivered-to-your-door',
    icon: SaucepanIconSvg,
    iconLabel: 'Ingredients in Saucepan',
    text: (
      <>
        <Nowrap>Real food,</Nowrap> <Nowrap>gently cooked</Nowrap>
      </>
    ),
  },
  {
    id: 'loved-by-millions',
    icon: HeartIconSvg,
    iconLabel: 'Heart',
    text: (
      <>
        Loved <Nowrap>by millions </Nowrap>
      </>
    ),
  },
];

export const vetsNegativeValueProps: HeroIconItem[] = [
  {
    id: 'real-food-gently-cooked',
    icon: SaucepanIconSvg,
    iconLabel: 'Dog food ingredients',
    text: <Nowrap>Gently cooked</Nowrap>,
  },
  {
    id: 'human-grade-safety',
    icon: IngredientsIconSvg,
    iconLabel: 'Ingredients in Saucepan',
    text: <Nowrap>Human-grade</Nowrap>,
  },
  {
    id: 'free-delivery',
    icon: DeliveredIconSvg,
    iconLabel: 'Dog food delivery box',
    text: <Nowrap>Free delivery</Nowrap>,
  },
];

export const vetsPositiveValueProps: HeroIconItem[] = [
  {
    id: 'real-food-gently-cooked',
    icon: SaucepanIconSvg,
    iconLabel: 'Dog food ingredients',
    text: <Nowrap>Gently cooked</Nowrap>,
  },
  {
    id: 'human-grade-safety',
    icon: IngredientsIconSvg,
    iconLabel: 'Ingredients in Saucepan',
    text: <Nowrap>Human-grade</Nowrap>,
  },
  {
    id: 'free-delivery',
    icon: DeliveredIconSvg,
    iconLabel: 'Dog food delivery box',
    text: <Nowrap>Free delivery</Nowrap>,
  },
];
